import React from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import Button from "../input/button";
import { setOverlayVisible } from "../../redux/actions/overlay";

const ConfirmOverlay = ({
  confirmCallback,
  cancelCallback,
  confirmationText,
  overlaySource,
}) => {
  const dispatch = useDispatch();

  return (
    <div className="confirm-overlay overlay_contents">
      <Typography variant="h3" className="confirm-overlay__confirmation-text">
        {confirmationText}
      </Typography>
      <div className="confirm-overlay_footer">
        <Button
          text="Cancel"
          color="red"
          size="large"
          onClick={() => {
            if (cancelCallback) {
              cancelCallback();
            }

            if (overlaySource) {
              dispatch(setOverlayVisible({ visible: true, ...overlaySource }));
            } else {
              dispatch(setOverlayVisible({ visible: false }));
            }
          }}
        />
        <Button
          text="Confirm"
          color="green"
          size="large"
          confetti={true}
          onClick={() => {
            setTimeout(() => {
              if (confirmCallback) {
                confirmCallback();
              }

              if (overlaySource) {
                dispatch(
                  setOverlayVisible({ visible: true, ...overlaySource }),
                );
              }
            }, 200);
          }}
        />
      </div>
    </div>
  );
};

export default ConfirmOverlay;
